import { ArrayHelpers, Field, FieldArray } from 'formik';
import React from 'react';
import { InvitationDefinitionInput } from '../../../../../primary-record-types/OrganizationTypes';
import Stack, { contentStackSpacing } from '../../../../v2BaseComponents/Stack';
import { getSpacing } from '../../../../../utils/spacing';
import Text from '../../../../v2BaseComponents/Text';
import { getIntl } from '../../../../../utils/intl';
import IconButton from '../../../../v2BaseComponents/IconButton';
import { useIsDisabledByParent } from '../../../../v2BaseComponents/IsDisabledProvider';
import { FormikInputs } from '../../../../v2BaseComponents/Inputs';
import { required } from '../../../../../utils/validators';
import Divider from '../../../../v2BaseComponents/Divider';
import { OrganizationTypes } from '../../../../../primary-record-types';
import FormInputSection from '../FormInputSection';

const intl = getIntl('invitation-definition-form-fields-checkboxes', {
    consentCheckbox: 'Consent Checkboxes',
    consentCheckboxLabel: 'Consent Checkbox #{index}',
    checkboxText: 'Checkbox Text',
});

export type CheckboxesFieldOwnProps = {
    isDisabled: boolean;
    values: OrganizationTypes.InvitationDefinitionInputConsentCheckbox[];
};

export type CheckboxesFieldProps = CheckboxesFieldOwnProps;

const CheckboxField: React.FC<{
    index: number;
    onRemove: () => void;
    isDisabled: boolean;
}> = (props) => {
    return (
        <FormInputSection
            title={intl('consentCheckbox')}
            removeTestID={`remove-input-${props.index}`}
            onRemove={props.onRemove}
            isDisabled={props.isDisabled}
        >
            <Field
                name={`checkboxInputs.${props.index}.label`}
                component={FormikInputs.Input}
                isRequired
                validate={required}
                title={intl('checkboxText')}
            />
        </FormInputSection>
    );
};

const CheckboxesField: React.FC<CheckboxesFieldProps> = (props) => {
    const isDisabled = useIsDisabledByParent(props.isDisabled);
    return (
        <FieldArray name="checkboxInputs">
            {(arrayHelpers: ArrayHelpers<InvitationDefinitionInput[]>) => (
                <Stack
                    vertical
                    space={contentStackSpacing}
                    fullWidth
                    style={{ marginTop: getSpacing(2.5), marginBottom: getSpacing(2.5) }}
                >
                    <Stack horizontal justify={'space-between'} align="center" fullWidth>
                        <Text variant="h5">{intl('consentCheckbox')}</Text>
                        <IconButton
                            testID="add-input"
                            icon="Plus"
                            variant="transparent"
                            onPress={() => {
                                const newValue: InvitationDefinitionInput = {
                                    type: 'consent-checkbox',
                                    label: '',
                                };
                                arrayHelpers.push(newValue);
                            }}
                            isDisabled={isDisabled}
                        />
                    </Stack>
                    {props.values.map((image, index) => (
                        <CheckboxField
                            key={index}
                            onRemove={() => arrayHelpers.remove(index)}
                            index={index}
                            isDisabled={props.isDisabled}
                        />
                    ))}
                    {props.values.length ? <Divider horizontal /> : null}
                </Stack>
            )}
        </FieldArray>
    );
};

export default React.memo(CheckboxesField);
